/**
 * Asynchronously loads the component for ProcessesPage
 */

import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "ProcessesPage" */ './index'), {
  fallback: <LoadingPage delay={1} />
})
